// Fashion & Beauty V1: register chooser — a parent product forces selection of the exact sellable variant.
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { money } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Package } from "lucide-react";
import { imgSrc } from "@/lib/img";
import { Swatch } from "@/components/fashion/VariantManager";

export default function VariantPicker({ parent, onPick, onClose }) {
  const [variants, setVariants] = useState(null);
  useEffect(() => {
    if (!parent) { setVariants(null); return; }
    api.get(`/products/${parent.id}/variants`).then((r) => setVariants(r.data.variants)).catch(() => setVariants([]));
  }, [parent]);
  return (
    <Dialog open={!!parent} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="variant-picker">
        <DialogHeader>
          <DialogTitle className="font-head">Choose a variant — {parent?.name}</DialogTitle>
          <DialogDescription>Pick the exact size / colour / shade being sold. Scanning the variant's own barcode adds it directly.</DialogDescription>
        </DialogHeader>
        {!variants ? <p className="text-muted-foreground">Loading…</p> : (
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {variants.map((v) => {
              const out = v.quantity <= 0;
              const img = imgSrc(v) || imgSrc(parent);
              return (
                <button key={v.id} type="button" disabled={out} onClick={() => onPick(v)} data-testid={`variant-pick-${v.id}`}
                  className="text-left rounded-xl border border-border p-3 hover:border-accent/60 hover:shadow-md transition-all active:scale-95 disabled:opacity-40">
                  <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-secondary/60 mb-2 flex items-center justify-center relative">
                    {img ? <img src={img} alt="" className="w-full h-full object-cover" /> : <Package className="w-7 h-7 text-muted-foreground/40" />}
                    {!v.image_path && v.swatch && <span className="absolute bottom-1.5 right-1.5"><Swatch color={v.swatch} className="w-5 h-5 ring-2 ring-background" /></span>}
                  </div>
                  <p className="font-semibold text-sm leading-snug flex items-center gap-1.5"><Swatch color={v.swatch} />{v.variant}</p>
                  <p className="text-xs text-muted-foreground mono">{money(v.price)} · {out ? "Out of stock" : `${v.quantity} in stock`}</p>
                </button>
              );
            })}
            {variants.length === 0 && <p className="col-span-full text-muted-foreground text-sm" data-testid="variant-picker-empty">No variants have been set up for this product yet.</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
